import React, { memo } from 'react';

function PhaseSection({ phase, count, expanded, onToggle, children }) {
  return (
    <section style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
      <button
        type="button"
        onClick={onToggle}
        style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 10,
          padding: '8px 10px',
          borderRadius: 8,
          background: 'rgba(99,102,241,0.06)',
          border: '1px solid rgba(99,102,241,0.14)',
          color: 'var(--text-secondary)',
          cursor: 'pointer',
          userSelect: 'none',
        }}
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
          <span style={{ fontSize: 12, width: 18, textAlign: 'center' }}>{expanded ? '▼' : '▶'}</span>
          <span style={{ fontSize: 12, fontWeight: 800, color: 'var(--text-primary)', letterSpacing: '-0.01em' }}>
            {phase}
          </span>
          <span style={{ fontSize: 12, color: 'var(--text-muted)', fontWeight: 600 }}>
            ({count})
          </span>
        </span>
        <span style={{ fontSize: 11, color: 'var(--text-muted)', fontFamily: "'JetBrains Mono', monospace" }} />
      </button>

      {expanded ? <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>{children}</div> : null}
    </section>
  );
}

export default memo(PhaseSection);

